const LOW = 10;
const HIGH = 101;

export default (value: number, low: number = LOW, high: number = HIGH) => {
  if (value <= low) {
    return "low";
  } else if (value >= high) {
    return "high";
  } else {
    return null;
  }
};
